import "../Menu.scss";
import { useState } from "react";
import { Link } from "react-router-dom";
import cupcakeFeature1 from "../../../assets/menu/cupcakes/cupcake-feature1.jpeg";
import cupcakeFeature2 from "../../../assets/menu/cupcakes/cupcake-feature2.jpeg";
import cupcakeFeature3 from "../../../assets/menu/cupcakes/cupcake-feature3.jpeg";
import cupcakeFeature4 from "../../../assets/menu/cupcakes/cupcake-feature4.jpeg";
import {
  GFIcon,
  EgglessIcon,
  DairyFreeIcon,
  VeganIcon,
} from "../../../assets/global/Icons";
import Tooltip from "../../../common/Tooltip";
import Accordion from "../../../common/Accordion";
import MenuNav from "../MenuNav";
import MenuGallery from "../MenuGallery";
import cupcakeFlavors from "./cupcakeFlavors.json";
import frostingOptions from "./frostingOptions.json";
import pricingOptions from "./pricing.json";

function Cupcakes() {
  const [flavorsOpened, setFlavorsOpened] = useState(false);
  const [frostingsOpened, setFrostingsOpened] = useState(false);
  const [pricingOpened, setPricingOpened] = useState(false);

  return (
    <div className="wrapper">
      <h1>
        <Link to="/menu" className="menu-title-link">
          Menu
        </Link>
      </h1>
      <MenuNav />

      <MenuGallery
        image1={{
          src: cupcakeFeature1,
          alt: "Winnie the Pooh tsum tsum cupcakes",
        }}
        image2={{ src: cupcakeFeature2, alt: "Berry 1st birthday cupcakes" }}
        image3={{ src: cupcakeFeature3, alt: "Succulent mini cupcakes" }}
        image4={{ src: cupcakeFeature4, alt: "Spring floral cupcakes" }}
      />

      <Accordion
        className="menu-accordion"
        title="Cupcake Flavors"
        isOpen={flavorsOpened}
        onToggle={() => setFlavorsOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Allergens: Contains milk, eggs, wheat. All cupcakes by default are{" "}
            <strong>free of tree nuts</strong>. While we are able to accommodate
            certain dietary restrictions, please note that this is not a
            dedicated gluten-free kitchen.
          </p>
        </div>
        {cupcakeFlavors.map((flavor) => (
          <div key={flavor.id}>
            <h3>{flavor.flavor}</h3>
            {flavor.specialty && <span className="specialty">*</span>}
            <p>{flavor.description}</p>
            <p>
              <em>{flavor.pairings}</em>
            </p>
            <p className="customizations-heading">
              <em>Optional Customizations:</em>
            </p>
            <div className="customizations-container">
              {flavor.allergens.map((allergen) => (
                <>
                  {allergen === "gf" && (
                    <Tooltip icon={<GFIcon />} text="Can be made gluten free" />
                  )}
                  {allergen === "eggless" && (
                    <Tooltip
                      icon={<EgglessIcon />}
                      text="Can be made eggless"
                    />
                  )}
                  {allergen === "dairy-free" && (
                    <Tooltip
                      icon={<DairyFreeIcon />}
                      text="Can be made dairy free"
                    />
                  )}
                  {allergen === "vegan" && (
                    <Tooltip icon={<VeganIcon />} text="Can be made vegan" />
                  )}
                </>
              ))}
            </div>
          </div>
        ))}
        <div className="full-width">
          <p>
            <em>
              <span className="specialty">*</span> = specialty flavors, extra
              fees apply
            </em>
          </p>
        </div>
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Frosting Options"
        isOpen={frostingsOpened}
        onToggle={() => setFrostingsOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            If you'd like to substitute the frosting on your cupcakes, please
            select from the options below. Additional costs apply.
          </p>
        </div>
        {frostingOptions.map((option) => (
          <div key={option.id}>
            <h3>{option.option}</h3>
            <p>{option.description}</p>
            <p>
              <em>{option.pairings}</em>
            </p>
          </div>
        ))}
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Pricing"
        isOpen={pricingOpened}
        onToggle={() => setPricingOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Cupcakes are only sold by the dozen. Please note that starting
            prices reflect basic designs <em>without any customizations</em>.
            For custom or themed cupcakes that require additional artwork,
            please <Link to="/order">submit an order form</Link> to get a
            customized quote.
          </p>
        </div>
        {pricingOptions.map((option) => (
          <div key={option.id}>
            <h3>{option.size}</h3>
            <p>
              {option.serves}
              <br />
              {option.pricing}
            </p>
          </div>
        ))}
      </Accordion>
    </div>
  );
}

export default Cupcakes;
